/**
 * @module router/modules/repair
 * @description 수리 접수 도메인 라우트 모듈 — 접수 등록, 이력 조회, 현황 관리,
 * 고객 관리, 수리 직원/소속 관리, 급지 관리, 비용 변경 팝업 경로를 정의합니다.
 */
const routes = [
  {
    path: '/repair-request-registration',
    name: '접수 등록',
    component: () => import(/* webpackChunkName: "repairRequestRegistration" */ '../../views/repairRequest/RepairRequestRegistration.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-request-history',
    name: '접수 이력',
    component: () => import(/* webpackChunkName: "repairRequestHistory" */ '../../views/repairRequest/RepairRequestHistory.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/repair-request-history-detail',
    name: '접수 이력 상세',
    component: () => import(/* webpackChunkName: "repairRequestHistoryDetail" */ '../../views/repairRequest/RepairRequestHistoryDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-request-history-detail/:id/:partnerId',
    name: '접수 이력 상세 파라미터',
    component: () => import(/* webpackChunkName: "repairRequestHistoryDetail" */ '../../views/repairRequest/RepairRequestHistoryDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/customer-management',
    // ko.json `menu.customerManagement` ("민원 고객 관리") 와 일치시켜
    // 메뉴 클릭(menuName 전달) / 직접 URL 진입(route.name fallback) 양쪽에서 동일하게 표시되도록 정정.
    name: '민원 고객 관리',
    component: () => import(/* webpackChunkName: "customerManagement" */ '../../views/repairRequest/CustomerManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  // SURINP-191 S7-1-A (2026-04-28): /customer-history 라우트 제거.
  // 기존 popup/CustomerHistory.vue + window.open 패턴 → CustomerHistoryModal 컴포넌트로 통합.
  {
    path: '/repair-request-management',
    name: '접수 현황 관리',
    component: () => import(/* webpackChunkName: "repairRequestManagement" */ '../../views/repairManagement/RepairRequestManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/repair-request-management-detail',
    name: '접수 현황 관리 상세',
    component: () => import(/* webpackChunkName: "repairRequestManagementDetail" */ '../../views/repairManagement/RepairRequestManagementDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-request-management-detail/:id/:partnerId',
    name: '접수 현황 관리 상세 파라미터',
    component: () => import(/* webpackChunkName: "repairRequestManagementDetail" */ '../../views/repairManagement/RepairRequestManagementDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-completed-detail',
    name: '접수 완료 내역 조회',
    component: () => import(/* webpackChunkName: "repairCompletedDetail" */ '../../views/repairManagement/RepairCompletedDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-completed-detail/:id/:partnerId',
    name: '접수 완료 내역 조회 파라미터',
    component: () => import(/* webpackChunkName: "repairCompletedDetail" */ '../../views/repairManagement/RepairCompletedDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-1-B (2026-04-29): /repair-fee-update 라우트 제거.
  // 기존 popup/RepairFeeUpdate.vue + window.open 패턴 → RepairFeeUpdateModal 컴포넌트로 통합.
  {
    path: '/repair-staff-team-management',
    name: '수리 직원 소속 관리',
    component: () => import(/* webpackChunkName: "repairStaffTeamManagement" */ '../../views/repairManagement/RepairStaffTeamManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-2-A (2026-04-29): /repair-staff-team-register 라우트 제거.
  // 기존 popup/RepairStaffTeamRegister.vue + window.open 패턴 → RepairStaffTeamRegisterModal 컴포넌트로 통합.
  {
    path: '/repair-staff-management',
    name: '수리 직원 관리',
    component: () => import(/* webpackChunkName: "repairStaffManagement" */ '../../views/repairManagement/RepairStaffManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-2-B (2026-04-29): /repair-staff-register 라우트 제거.
  // 기존 popup/RepairStaffRegister.vue + window.open 패턴 → RepairStaffRegisterModal 컴포넌트로 통합.
  {
    path: '/visit-difficulty-type-management',
    // 추가비용(구 급지) 관리 - 지역 별 차등 금액 설정
    name: '추가비용 관리',
    component: () => import(/* webpackChunkName: "visitDifficultyTypeManagement" */ '../../views/repairManagement/VisitDifficultyTypeManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/repair-travel-fee-management',
    // 출장비 관리 (SURINP-192)
    name: '출장비 관리',
    component: () => import(/* webpackChunkName: "repairTravelFeeManagement" */ '../../views/repairManagement/RepairTravelFeeManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  }
]

export default routes
